module.exports = __webpack_public_path__ + "img/jacqueline-martin@2x.ac8dcffc.jpg";